import * as React from 'react';
import { SsqImages } from 'images/SsqImages';
import { i18ntrans, tc } from 'language/i18nkey';
import { useZstdInfo } from 'zstd/useZstdInfo';
import styled from 'styled-components';
import icon_user_settings from './icon/user_setting.svg';

type Props = {};
export const RenderUserModifyPage = (props: Props) => {
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const { setShowManageMyInfoPopup } = useZstdInfo();
  return (
    <Userstate>
      <button
        onClick={() => {
          setShowManageMyInfoPopup(true);
        }}
      >
        <div>
          <img alt={'user_settings.svg'} src={icon_user_settings} />
          {/* {trans("I18N_TITLE_USER_SETTINGS")} */}
          {tc('i18n_head_menu_account_settings')}
        </div>
      </button>
    </Userstate>
  );
};

const Userstate = styled.div`
  padding: 0 1rem;
  button {
    padding: 1.6rem 2.2rem;
  }
`;
